import React, { Suspense } from "react";
import ProtectedRoute from "ProtectedRoute";
import ElectricalServicesOutlinedIcon from "@mui/icons-material/ElectricalServicesOutlined";

// Plan K Phase 6 — LOTO frontend module. Stage 0: electrical panels +
// breakers UI on top of the loto-api endpoints. Future phases add LOTO
// procedures, events, locks/tags, inspections, contractor authorizations.
// Plan L Phase L4 — Emergency Lighting compliance page added; consumes
// inspections-api + loto-api (breakers) + flex2-api (assets).
//
// appMode positioning: LOTO is a facility / safety capability — NOT part
// of AFMS (recycling / environmental). Tagged `appMode: "flex2"` so the
// Lockout / Tagout group lives in the standard sidenav and is hidden from
// the AFMS sidenav. If LOTO gets its own dedicated appMode later (own
// pricing lane), swap this constant; the rest of the module stays put.
//
// Lane positioning is orthogonal: pricing-wise, LOTO currently rolls under
// `lane.environmental` per Plan K § 3 (working assumption — pending its own
// pricing lane). The lane gate controls *who is entitled*; the appMode tag
// controls *which sidebar surfaces it*.
const PanelsList = React.lazy(() => import("loto/pages/PanelsList"));
const PanelDetail = React.lazy(() => import("loto/pages/PanelDetail"));
const EmergencyLights = React.lazy(() => import("loto/pages/EmergencyLights"));

const lotoRoutes = [
  {
    type: "collapse",
    name: "Lockout / Tagout",
    key: "loto",
    icon: <ElectricalServicesOutlinedIcon />,
    appMode: "flex2",
    laneKey: "lane.environmental",
    collapse: [
      {
        name: "Electrical Panels",
        key: "loto-panels-list",
        route: "/loto/panels",
        appMode: "flex2",
        component: (
          <ProtectedRoute>
            <Suspense fallback={null}>
              <PanelsList />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        name: "Emergency Lighting",
        key: "loto-emergency-lights",
        route: "/loto/emergency-lights",
        appMode: "flex2",
        component: (
          <ProtectedRoute>
            <Suspense fallback={null}>
              <EmergencyLights />
            </Suspense>
          </ProtectedRoute>
        ),
      },
    ],
  },
  // Detail route — hidden from the sidenav (no `type: "collapse"`).
  {
    type: "hidden",
    key: "loto-panel-detail",
    route: "/loto/panels/:publicId",
    appMode: "flex2",
    laneKey: "lane.environmental",
    component: (
      <ProtectedRoute>
        <Suspense fallback={null}>
          <PanelDetail />
        </Suspense>
      </ProtectedRoute>
    ),
  },
];

export default lotoRoutes;
